module.exports = __webpack_public_path__ + "img/card-cero-web.38fc1d2b.png";